import { apiInterfaceForJson } from "../common/apiManager";

export const fetchDesks = () => {
    return apiInterfaceForJson("/desk/v1/", "GET");
};

export const fetchAvailableDesks = () => {
    return apiInterfaceForJson("/desk/v1/available", "GET");
};

export const searchDesks = (query) => {
    return apiInterfaceForJson("/desk/v1/search", "POST", query);
};

export const getDeskDataById = (deskId) => {
    return apiInterfaceForJson("/desk/v1/" + deskId, "GET");
};

export const getDeskDetailsById = (deskId) => {
    return apiInterfaceForJson("/desk/v1/details/" + deskId, "GET");
};

export const createDesk = (deskDetails) => {
    return apiInterfaceForJson("/desk/v1/", "POST", deskDetails);
};

export const updateDesk = (deskDetails) => {
    return apiInterfaceForJson("/desk/v1/", "PUT", deskDetails);
};

export const updateDeskBackgroundThemeColor = (deskDetails) => {
    return apiInterfaceForJson("/desk/v1/update", "POST", deskDetails);
};

export const updateDevice = (deviceDetails) => {
    let deskDeviceInfo = {
        _id: deviceDetails.id,
        device_id: deviceDetails.deviceId
    };
    return apiInterfaceForJson("/desk/v1/updateDevice", "POST", deskDeviceInfo);
};

export const deleteDesk = (deskDetails) => {
    return apiInterfaceForJson("/desk/v1/delete", "POST", deskDetails);
};
